import React from "react";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import { Flex, Text } from "@jsq/ds/core";
import {
  textOnDark,
  tooltipArrowDown,
  tooltipBox,
  tooltipHost,
  tooltipLeftVar,
  tooltipRow,
  tooltipSwatch,
  tooltipSwatchColorVar,
  tooltipTopVar,
} from "./styles_vanilla.css";
import type { DonutTooltipProps } from "./types";

export const DonutTooltip: React.FC<DonutTooltipProps> = ({ hovered }) => {
  const { segment, anchorX, anchorY } = hovered;

  const hostVars = assignInlineVars({
    [tooltipTopVar]: `${anchorY}px`,
    [tooltipLeftVar]: `${anchorX}px`,
  });

  return (
    <Flex
      role="tooltip"
      flexDirection="column"
      alignItems="center"
      className={tooltipHost}
      style={hostVars}
    >
      <Flex alignItems="center" className={tooltipBox}>
        <Flex alignItems="center" className={tooltipRow}>
          <div
            className={tooltipSwatch}
            style={assignInlineVars({ [tooltipSwatchColorVar]: segment.color })}
          />
          <Text asSpan variant="regular-md" className={textOnDark}>
            {segment.label}
          </Text>
        </Flex>
        <Text asSpan variant="regular-md" className={textOnDark}>
          {segment.value.toLocaleString()}
        </Text>
      </Flex>
      <div className={tooltipArrowDown} />
    </Flex>
  );
};
